import React from "react";
import "./ActiveRestaurantModal.scss";

const ActiveRestaurantModal = ({
  isOpen,
  activeSession,
  onGoToActive,
  onLogout,
}) => {
  if (!isOpen) return null;

  return (
    <div className="restaurant-modal-overlay">
      <div className="restaurant-modal-card">
        <div className="restaurant-modal-icon">⚠️</div>
        <h3>Active Dining Session</h3>
        <p className="restaurant-modal-msg">
          You have an ongoing unbilled order at{" "}
          <strong>
            {activeSession?.restaurantName || "your previous restaurant"}
          </strong>{" "}
          (Table {activeSession?.tableNumber || "T-1"}).
        </p>
        <p className="restaurant-modal-submsg">
          Please complete your bill payment or log out before ordering at a new
          location.
        </p>

        <div className="restaurant-modal-actions">
          <button className="btn active-restaurant-btn" onClick={onGoToActive}>
            View Current Bill / Order
          </button>
          <button className="logout-fresh-btn" onClick={onLogout}>
            Log Out & Clear Session
          </button>
        </div>
      </div>
    </div>
  );
};

export default ActiveRestaurantModal;
